<template>
  <div>
    <v-data-table
      class="astra-table"
      dense
      height="76vh"
      fixed-header
      :headers="controller.headers"
      :options.sync="controller.options"
      :server-items-length="controller.releaseConfirmationPagination.total"
      :items="controller.releaseConfirmationPagination.items"
      :loading="controller.loading"
      :footer-props="{
        'items-per-page-options': [40, 80],
      }"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex">
          <v-btn
            class="action-btn d-flex justify-center mr-2"
            height="25"
            color="success"
            small
            tile
            @click="controller.confirmRelease(item)"
            :loading="controller.loading"
            :disabled="item.rejected || item.allowed || item.passwordGenerated"
          >
            <v-icon left small>mdi-check</v-icon>
            {{ item.allowed ? 'Confirmado' : 'Confirmar' }}
          </v-btn>

          <v-btn
            class="action-btn d-flex justify-center"
            height="25"
            color="error"
            small
            tile
            @click="controller.rejectRelease(item)"
            :loading="controller.loading"
            :disabled="item.rejected || item.allowed || item.passwordGenerated"
          >
            <v-icon left small>mdi-close</v-icon>
            {{ item.rejected ? 'Rejeitado' : 'Rejeitar' }}
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.createdDate`]="{ item }">
        {{ dayjs(item.createdDate).format("DD/MM/YYYY HH:mm") }}
      </template>

      <template v-slot:top>
        <v-row class="pa-3" no-gutters>
          <v-col
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'py-3 d-flex align-center justify-center'
                : 'd-flex align-center'
            "
            cols="12"
            sm="12"
            md="6"
            lg="4"
            xl="6"
          >
            <span class="table-title">Solicitações para geração de senha</span>
          </v-col>
          <v-col
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'd-flex flex-column align-center justify-center'
                : 'd-flex align-center justify-end'
            "
            cols="12"
            sm="12"
            md="6"
            lg="8"
            xl="6"
          >
            <v-btn
            class="mr-2"
            color="primary"
            small
            @click="navigateToEquipmentStatus"
          >
            <v-icon left small>mdi-radio-tower</v-icon>
            Status dos Equipamentos
          </v-btn>
            <v-select
              outlined
              dense
              color="primary"
              v-model="controller.statusSelected"
              :items="controller.statusList"
              hide-details
              style="max-width: 200px"
              class="pa-2 search-tf"
              item-text="text"
              item-value="value"
              @change="controller.changeStatus()"
            ></v-select>
            <v-text-field
              class="ma-2 search-tf"
              style="max-width: 350px"
              outlined
              color="primary"
              hide-details
              dense
              placeholder="Pesquisar motorista/rede/equipamento..."
              v-model="controller.search"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

 <script>
import { releaseConfirmationController } from "@/di/di";
import dayjs from "dayjs";
import { bus } from '@/main';
export default {
  name: "releaseConfirmationPage",
  computed: {
    dayjs() {
      return dayjs
    }
  },
  data: (context) => ({
    controller: releaseConfirmationController(context),
  }),
  watch: {
    "controller.options"() {
      this.controller.watchOptions();
    },
    "controller.search"() {
      this.controller.watchSearch();
    },
  },
  methods: {
    navigateToEquipmentStatus() {
      bus.$emit('toPage', 12);
    }
  }
};
</script> 

<style scoped lang="scss">
.astra-table {
  border-radius: 20px;
  background-color: var(--v-secondary-base) !important;
}

.toolbar-table {
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
}

::v-deep .v-data-table.v-data-table--fixed-header thead th {
  background-color: var(--v-secondary-base) !important;
}

.action-btn {
  text-transform: none;
  border-radius: 10px !important;
}

.search-tf {
  border-radius: 10px !important;
}

.table-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 20px;
  text-align: center;
}

.crud-card {
  border-radius: 20px;
  background-color: var(--v-secondary-base) !important;
}

::v-deep .v-dialog {
  border-radius: 20px !important;
}

label {
  order: -1;
}

.v-input:focus-within + label {
  color: var(--v-primary-base) !important;
}

.form-input-group {
  display: flex;
  flex-direction: column;
}

::v-deep tbody {
  tr:hover {
    background-color: var(--v-tertiary-base) !important;
  }
}
</style>
